import type { LiveInputs, LiveInputsPostLinkInterface } from '../../types'

import { tupleToKeyValue } from '@app/utils/tuples'

class LiveInputsPostLink implements LiveInputsPostLinkInterface {
  private liveInputs: LiveInputs
  private inputFilter: string = "[data-behaviour~='live-inputs-post-link']"

  constructor(liveInputs: LiveInputs) {
    this.liveInputs = liveInputs
    this.initializeListeners()
  }

  private initializeListeners(): void {
    this.liveInputs.on('click', this.inputFilter, liveInputClick)
  }

  teardown(): void {
    this.liveInputs.off('click', this.inputFilter, liveInputClick)
  }
}

const liveInputClick = (event: Event): void => {
  event.preventDefault()

  const target = event.target as HTMLElement

  if (!target) {
    return
  }

  const [adjustmentParams, ledgerId] = extractParams(target)
  const keyValues = adjustmentParams.flatMap((tuple) =>
    tupleToKeyValue([tuple[0], tuple[1] || ''])
  )

  if (keyValues.length === 0 || !ledgerId) {
    return
  }

  window.modalCitizen.openModalPortal('adjustments-modal', {
    data: keyValues,
    ledgerId,
    mode: 'build',
  })
}

const extractParams = (element: HTMLElement): [string[][], string] => {
  const paramString = element?.dataset?.adjustmentParams || '[]'
  return [
    JSON.parse(paramString) as string[][],
    element?.dataset?.ledgerId || '',
  ]
}

export default LiveInputsPostLink
